<div class="flex flex-col border rounded-md border-neutral-100 h-full">
  <div
    class="flex gap-1 items-center bg-neutral-50 p-2 gap-1 rounded-t-md border-b border-neutral-100"
  >
    <flx-select
      [formControl]="viewModeFC"
      class="flx-ds small"
      data-testid="variables-view-mode-select"
    >
      @for (option of viewVariablesOptions; track option.value) {
        <flx-select-option
          [value]="option"
          [attr.data-testid]="'variables-view-mode-' + option.value"
        >
          {{ option.label }}
        </flx-select-option>
      }
    </flx-select>
    <button
      (click)="exportVariables()"
      class="flx-ds secondary small"
      flxButton
      data-testid="export-variables"
      type="button"
      variant="text"
    >
      Export JSON
    </button>
    @if (variableAccessRights().canEdit) {
      <button
        [disabled]="disableEditorModal()"
        (click)="toggleEditorModal(true)"
        class="flx-ds primary small ml-auto"
        flxButton
        data-testid="edit-variables"
        type="button"
        variant="text"
      >
        Modify Variables
      </button>
    }
  </div>
  <div
    [class.overflow-auto]="viewModeValue() === 'tree'"
    class="p-2 h-full"
  >
    @if (paramValues()) {
      @switch (viewModeValue()) {
        @case ('tree') {
          <flx-json-viewer
            [json]="paramValues()"
            [expanded]="false"
            class="block overflow-y-auto"
          />
        }
        @case ('json') {
          <flx-code-editor
            [ngModel]="stringifiedVariables()"
            [options]="defaultJsonEditorOptions"
            [readonly]="true"
            class="w-full h-full grow"
            data-testid="variables-json-editor"
          />
        }
      }
    } @else {
      <div class="flex justify-center items-center h-full text-neutral-400">
        No variables available.
      </div>
    }
  </div>
</div>
<ng-template
  [flxShowModal]="showEditorModal | async"
  panelClass="w-[calc(100%-80px)] h-[96%]"
>
  <app-process-instance-variables-editor-modal
    [variables]="processInstance()?.paramValues"
    [readOnly]="disableEditorModal()"
    (hide)="toggleEditorModal()"
  >
    <!-- Process instance info -->
    @if (processInstance() && processDefinition()) {
      <flx-process-instance-details-panel-header
        [state]="processInstance().state"
        [name]="processDefinition().resourceName"
        [uuid]="processInstance().uuid"
        subtitle
      />
    }

    <!-- Warning info -->
    <flx-helper
      class="flex w-auto bg-neutral-50 rounded p-2 gap-2 items-center"
      info
    >
      <i class="ph ph-lightbulb text-yellow-500 text-base"></i>
      <span>
        You may need to modify an active process instance to allow execution to continue. The
        execution may be stuck, and you may want to continue the execution on a different activity
        (i.e. skip or repeat activities). Review the
        <a
          [href]="docsLink"
          class="text-blue-500 underline"
          clickStopPropagation
          target="_blank"
        >
          change variables documentation
        </a>
        to learn how to proper use this operation.
      </span>
    </flx-helper>
  </app-process-instance-variables-editor-modal>
</ng-template>
